import { Theme } from "@mui/material/styles";
import { makeStyles, createStyles } from "@mui/styles";

export const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		inputAutoComplete: {
			"& .MuiSvgIcon-root": {
				color: theme.palette.primary.main,
			},
			"& .Mui-disabled": {
				backgroundColor: "#d7d7d7",
			},
			"& .MuiFormHelperText-root": {
				background: "none",
			},
		},
		inputText: {
			width: "100%",
			borderRadius: "10px",
			overflow: "hidden",

			"& .MuiFilledInput-root": {
				background: "#fff",
				borderRadius: "inherit",
				overflow: "hidden",
			},

			"& .MuiFilledInput-underline:before": {
				borderBottom: "none",
			},

			"& .MuiFilledInput-underline:after": {
				borderColor: theme.palette.primary.main,
			},
			"& .MuiFilledInput-underline.Mui-error:after": {
				borderColor: "#f44336",
			},
			"& .MuiSelect-icon": {
				color: theme.palette.primary.main,
			},
			"& .MuiFormLabel-asterisk": {
				color: "red",
			},
			"& .Mui-disabled": {
				backgroundColor: "#d7d7d7",
			},
			"& .MuiFormHelperText-root.Mui-disabled": {
				color: theme.palette.error.main,
				background: "none",
			},
		},
		containerLoading: {
			padding: "10px 0px 10px 16px",
			color: theme.palette.common.black,
			fontWeight: "bold",
		},
		containerResultsFound: {
			padding: "10px 0px 5px 16px",
			color: theme.palette.common.black,
			fontWeight: "bold",
		},
	}),
);
